import { FC } from 'react';
import { SubNavBarProps } from '../interface/interface';
import { ArrowRightIcon } from '../assets/svgImages';

const SubNavBar: FC<SubNavBarProps> = ({ items, isVisible, isMobile }) => {
  return (
    <div
      className={`bg-secondary-pink-100 px-4 md:py-4 w-full justify-between items-center fixed ${
        isMobile
          ? 'py-2 z-[99] transition-transform duration-500 lg:hidden'
          : 'py-3 z-30 hidden'
      } ${
        isMobile
          ? isVisible
            ? 'translate-y-2 bottom-20'
            : 'translate-y-96 -bottom-20'
          : isVisible
            ? 'lg:block'
            : ''
      }`}
    >
      <div className="flex flex-wrap justify-center items-center mx-auto">
        {items.map((item, index) => (
          <a
            key={index}
            href={item.href}
            className={`bg-white text-primary-blue-500 font-semibold shadow p-4 
              flex justify-between items-center rounded-lg capitalize m-4
              border border-white 
              ${isMobile ? 'text-sm w-72 active:border-primary-blue-500 hover:border-primary-blue-500' : 'text-base md:w-80 hover:border-primary-blue-500'}
              `}
          >
            <div className="flex items-center">
              {item.icon}
              <span className="ml-2">{item.name}</span>
            </div>
            <div>
              <ArrowRightIcon className="h-6 w-6" />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SubNavBar;
